export default "__VITE_ASSET__CzQMNDj4__"